import { render } from "./Definition_of_basic_measures_SupportMeasures.vue?vue&type=template&id=70c67184&scoped=true"
import script from "./Definition_of_basic_measures_SupportMeasures.vue?vue&type=script&lang=js"
export * from "./Definition_of_basic_measures_SupportMeasures.vue?vue&type=script&lang=js"

import "./Definition_of_basic_measures_SupportMeasures.vue?vue&type=style&index=0&id=70c67184&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c67184"]])

export default __exports__